export function getInOutDataObject(nodeValue: number, campaignTotal: number) {
  const calculatedTotal = calculatePartOFTotals(campaignTotal, nodeValue);

  return {
    value: nodeValue,
    percentageOfTotal: calculatedTotal,
  };
}

function calculatePartOFTotals(total: number, value: number): number {
  return total ? value / total : 0;
}
